// Published baseline entitlement per plan tier, independent of what a
// specific client's license doc is actually configured to (which can run
// higher as a year bonus — see LicenseTab.js and the onboarding plan-reveal
// step, both of which import this). Purely a display/marketing framing; has
// no bearing on real enforcement, which lives entirely in backend/license.py.
export const PLAN_BASELINES = {
  standard: { leads_this_year: 5000, enrolled_students: 250, courses: 50, batches: 150, users: 5 },
};

export const LIMIT_LABELS = {
  branches: 'Branches',
  users: 'Users',
  leads_this_year: 'Leads This Year',
  enrolled_students: 'Enrolled Students',
  courses: 'Courses',
  batches: 'Batches',
};
